import "./Banner.module.css";

import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";

import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import ScrollTrigger from "react-scroll-trigger";
import useSendEvent from "hooks/useSendEvent";

import arrow from "../../../assets/NewDesign/Home/Arrow.svg";
export default function Banner() {
  const [count1, setCount1] = useState(99900);
  const [isMobile, setIsMobile] = useState(false);
  const intervalIdRef = useRef(null);

  const { sendEvent } = useSendEvent();

  const counts = [{ count: count1, setter: setCount1, target: 100000 }];
  const updateCounts = () => {
    counts.forEach(({ count, setter, target }) => {
      if (count < target) {
        setter((prevCount) => Math.min(prevCount + 1, target));
      }
    });
  };

  const handleEnterViewport = () => {
    intervalIdRef.current = setInterval(() => {
      updateCounts();
    }, 40);
  };

  const handleExitViewport = () => {
    clearInterval(intervalIdRef.current);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(intervalIdRef.current);
    };
  }, []);

  const trackEvent = () => {
    sendEvent("Explore Courses", "home");
  };

  return (
    <ScrollTrigger onEnter={handleEnterViewport} onExit={handleExitViewport}>
      <section className="homeBanner pb-10">
        <div className="max-w-7xl md:mt-0 lg:mt-0 xl:mt-0 2xl:mt-0 mx-auto px-5 md:px-16 lg:px-16 xl:px-16 2xl:px-16 md:pt-16 lg:pt-16 xl:pt-16 2xl:pt-16">
          <div className="flex flex-col-reverse md:flex-row lg:flex-row xl:flex-row 2xl:flex-row h-auto justify-center py-5 md:h-auto mx-auto items-center">
            <div className="text w-full md:w-2/4 lg:w-2/4 xl:w-2/4 2xl:w-2/4 sm:text-center md:text-center lg:text-start">
              <div className="text-center md:text-start lg:text-start xl:text-start">
                <h1
                  className={`${
                    isMobile
                      ? "text-[30px] text-white flex flex-col leading-10"
                      : "flex flex-col gap-y-10 md:text-[40px] lg:text-[60px] xl:text-[60px] 2xl:text-[60px] font-bold text-white leading-0 md:leading-5 lg:leading-8 xl:leading-8 2xl:leading-8"
                  }`}
                >
                  <span>Upskill for a</span>
                  <span>Better Career</span>
                </h1>
              </div>

              {!isMobile && (
                <div className="flex gap-5 mt-5 md:mt-10 lg:mt-10 xl:mt-10 2xl:mt-10 justify-center md:justify-start lg:justify-start xl:justify-start 2xl:justify-start">
                  <AvatarGroup max={4}>
                    <Avatar
                      alt="student"
                      src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/NewDesign/Home/review/Md.+Mahathir.webp"
                      className="avatar"
                      style={{
                        objectFit: "contain",
                        background: "#fff",
                        zIndex: 30,
                      }}
                    />
                    <Avatar
                      alt="student"
                      src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/NewDesign/Home/review/Taneem+Ashraf+Jion.webp"
                      className="avatar"
                      style={{
                        objectFit: "contain",
                        background: "#fff",
                        zIndex: 20,
                      }}
                    />
                    <Avatar
                      alt="student"
                      src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/NewDesign/Home/review/Laila+Marium.webp"
                      className="avatar"
                      style={{
                        objectFit: "contain",
                        background: "#fff",
                        zIndex: 10,
                      }}
                    />
                  </AvatarGroup>

                  <div className="flex flex-col leading-[15px] ">
                    <span className="font-extralight text-white text-[20px]">
                      {count1}+
                    </span>
                    <span className="font-extralight text-white text-[18px]">
                      Satisfied
                    </span>
                    <span className="font-extralight text-white text-[18px]">
                      Students
                    </span>
                  </div>
                </div>
              )}
              <div className="flex items-center justify-center  md:justify-start lg:justify-start xl:justify-start 2xl:justify-start">
                <Link to="/allcourses" onClick={trackEvent}>
                  <button className="text-[30px] flex flex-col justify-start font-normal text-white">
                    <span style={{ letterSpacing: "6px", lineHeight: "30px" }}>
                      Explore <br /> Courses
                    </span>
                  </button>
                </Link>

                <Link to="/allcourses" onClick={trackEvent}>
                  <img
                    src={arrow}
                    className="w-[92px] h-auto mt-7 transform transition-transform hover:scale-110 animate-jelly"
                    alt="arrow"
                  />
                </Link>
              </div>
            </div>
            <div className="image w-full pt-10 md:pt-0 md:w-2/4 xl:w-2/4 2xl:w-2/4">
              <img
                src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/NewDesign/Home/IcWebsiteBanner.webp"
                alt="bannerImage"
                className={`${
                  isMobile ? "w-[300px] h-auto mx-auto" : "w-full mx-auto"
                }`}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </ScrollTrigger>
  );
}
